angular.module("acl.visualizer.shareToGRC", [
  "acl.common.config",
  "ui.router",
  "acl.common.event",
  "acl.common.localize",
  "acl.visualizer.saveViz",
  "ui.bootstrap",
]);
